/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../index';

/**
 * @example
 *     {
 *         data: {
 *             schema: {
 *                 fields: [{
 *                         kind: "BOOLEAN",
 *                         name: "name"
 *                     }]
 *             }
 *         }
 *     }
 */
export interface SchemaImportRequest {
    /** The annotations of the resource. */
    annotations?: Record<string, string>;
    data: Truvity.SchemaImportDataRequest;
    /** The labels of the resource. */
    labels?: Record<string, string>;
}
